import { render, staticRenderFns } from "./count-game.vue?vue&type=template&id=2fa2944e&scoped=true"
import script from "./count-game.vue?vue&type=script&lang=js"
export * from "./count-game.vue?vue&type=script&lang=js"
import style0 from "./count-game.vue?vue&type=style&index=0&id=2fa2944e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2944e",
  null
  
)

export default component.exports